var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information_shop"},[_c('div',{staticClass:"ic_shop"},[_c('img',{staticClass:"ic_shop_title",attrs:{"src":"/static/img/top/ic-store.svg","width":"20","height":"20"}}),_vm._v(" "),_c('span',{staticClass:"ic_shop_title loading-font"},[_vm._v("ストア")])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f377d8ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/InformationShop.vue
// module id = null
// module chunks = 